import React, { Component } from 'react'
import { Container } from './styles'
import Project from '../Project'

class ProjectGroup extends Component {
  render() {
    let { projects } = this.props
    return(
      <Container>
        { projects.map( (project, index) => <Project project={project} key={index} />)}
      </Container>
    )
  }
}

export default ProjectGroup



// WEBPACK FOOTER //
// ./src/Components/ProjectGroup/index.js